import { Box, CircularProgress, Container, Grid } from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import Card from "src/Component/card-components/Card";
import Header from "src/Component/content-component/Header";
import { getRegulatoryWebAsync } from "src/redux/services/testimonialService";

const Regulatory = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { regulatory, isRegulatoryLoading } = useSelector(
    (state) => state.testimonial
  );

  const handleNavigation = (path) => {
    if (path.startsWith("http")) {
      window.open(path, "_blank");
    } else {
      navigate(path);
    }
  };

  useEffect(() => {
    dispatch(getRegulatoryWebAsync());
  }, [dispatch]);

  return (
    <Box sx={{ backgroundColor: "#effdff", padding: "20px 0" }} id="colleges">
      <Container maxWidth="lg">
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: "30px",
          }}
        >
          <Header
            content={"Regulatory bodies for Internationalization"}
            textAlign="center"
          />
        </Box>

        <Grid
          container
          spacing={2}
          justifyContent="center"
          alignItems="center"
          marginBottom={2}
        >
          {isRegulatoryLoading ? (
            <CircularProgress />
          ) : (
            regulatory?.map((college, index) => (
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                lg={4}
                xl={4}
                key={index}
                sx={{ display: "flex", justifyContent: "center", mb: 2 }}
              >
                <Card
                  data={college}
                  borderRadius="10%"
                  hoverHeight="24%"
                  initialheight="24%"
                  width="100%"
                  height="75%"
                  listStyle="none"
                  fontSize="18px"
                  onClick={() => handleNavigation(college.link)}
                />
              </Grid>
            ))
          )}
        </Grid>
      </Container>
    </Box>
  );
};

export default Regulatory;
